var render = function render(_c,_vm){return _c('div',{staticClass:"block ce-frame",class:[
		`frame-${_vm.props.frameClass}`,
		`layout-${_vm.props.layout}`,
		`space-before-${_vm.props.spaceBefore}`,
		`space-after-${_vm.props.spaceAfter}`
	]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }